import { ButtonHTMLAttributes } from 'react'
import classNames from 'classnames'

import Spinner from '@/components/base/Spinner'
import Typography from '@/components/base/Typography'

type SubmitProps = ButtonHTMLAttributes<HTMLButtonElement> &
  Partial<{
    link: boolean
    dark: boolean
    color: string
    external: boolean
    className: string
    variant: 'contained' | 'outlined'
    fetching: boolean
  }>

const Submit = ({
  className,
  children,
  fetching,
  disabled,
  variant,
  ...props
}: SubmitProps) => {
  const variantClasses = classNames(
    'relative group inline-flex shrink-0 px-sm py-[1.27rem] rounded-xxs border-2 cursor-pointer',
    {
      'text-blue-soft bg-transparent border-transparent':
        variant !== 'contained' && variant !== 'outlined'
    },
    {
      'text-white bg-blue-soft border-blue-soft': variant === 'contained'
    },
    {
      'text-white bg-transparent border-white/30': variant === 'outlined'
    }
  )

  return (
    <button
      type="submit"
      className={classNames(
        variantClasses,
        { 'pointer-events-none opacity-50': disabled },
        className
      )}
      {...props}
    >
      <span
        data-label={children as string}
        className={classNames(
          'relative flex overflow-hidden py-[.45rem]',
          'after:absolute after:left-0 after:top-0 after:-my-[.45em] after:w-full after:translate-y-full after:py-[.45rem] after:font-inter after:text-button after:transition-transform after:duration-300 after:ease-out-cubic after:content-[attr(data-label)] pointer:group-hover:after:translate-y-0',
          { invisible: fetching }
        )}
      >
        <Typography
          variant="button"
          className="block transition-transform duration-300 ease-out-cubic pointer:group-hover:-translate-y-full"
        >
          {children}
        </Typography>
      </span>
      {fetching ? (
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
          <Spinner variant="small" />
        </div>
      ) : null}
    </button>
  )
}

export default Submit
